export default __webpack_public_path__ + "static/media/emergencyDeliverySong.d13600d1.mp3";